module.exports = __webpack_public_path__ + "media/images/novum-logo-animated-long-5c3b9cc3df932211021ffcac2a238fdd.svg";